module.exports = __webpack_public_path__ + "static/media/banner.1b45fb74.svg";